
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestparaquatlawyers/privacy-policy",
      function () {
        return require("private-next-pages/bestparaquatlawyers/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestparaquatlawyers/privacy-policy"])
      });
    }
  